/** Resolve bilingual CMS field: string | { id, en } */
export function bi(value, lang = "id") {
  if (value == null) return "";
  if (typeof value === "string") return value;
  if (typeof value === "object") {
    return value[lang] || value.id || value.en || "";
  }
  return String(value);
}

export function biList(list, lang = "id") {
  if (!Array.isArray(list)) return [];
  return list.map((item) => bi(item, lang)).filter((x) => String(x).trim() !== "");
}

export function biSet(current, lang, next) {
  const base =
    current && typeof current === "object" && !Array.isArray(current)
      ? { id: current.id || "", en: current.en || "" }
      : { id: typeof current === "string" ? current : "", en: typeof current === "string" ? current : "" };
  return { ...base, [lang]: next };
}

export function emptyBi(id = "", en = "") {
  return { id, en };
}

export function asBi(value, fallbackEn = "") {
  if (value && typeof value === "object" && !Array.isArray(value)) {
    return { id: value.id || "", en: value.en || fallbackEn || "" };
  }
  const s = typeof value === "string" ? value : "";
  return { id: s, en: fallbackEn || "" };
}

export function asBiList(list) {
  if (!Array.isArray(list)) return [];
  return list.map((item) => asBi(item));
}

export function biSearchText(value) {
  if (value == null) return "";
  if (typeof value === "string") return value;
  if (typeof value === "object") return `${value.id || ""} ${value.en || ""}`;
  return String(value);
}
